<template>
  <div class="xieyi">
    <h2>隐私协议</h2>
    <p>
      本协议系由您（或称“用户”）与东莞万饰网络科技有限公司（或称“我们”）就使用东莞市五金饰品行业协会平台以及其他我们开发的小程序服务（以下简称“平台”）共同签署本《隐私协议》（以下简称“本协议”）。
    </p>
    <p>
      我们深知个人信息对您的重要性，您的信赖对我们非常重要，我们将严格遵守法律法规要求采取相应的安全保护措施，致力于保护您的个人信息安全可控。基于此，我们制定本协议，帮助您充分了解在您使用我们提供服务的过程中，会如何收集、使用、共享、存储和保护您的个人信息以及您可以如何管理您的个人信息，以便您更好地作出适当的选择。
    </p>
    <p>
      在您开始使用我们的平台服务前，请您务必先仔细阅读和理解本协议，特别应重点阅读我们以粗体标识的条款，确保您充分理解和同意之后再开始使用。本协议中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。如果您对本协议有任何的疑问、投诉、意见和建议，欢迎您与我们沟通反馈，我们十分乐意为您解答。
    </p>
    <p>
      您点击签署本协议的同时表示您已了解应用提供的功能，以及功能运行所需的必要个人信息，并给予相应的收集使用授权，但并不代表您已单独同意开启附加功能、处理非必要个人信息，相关附加功能的开启、处理非必要个人信息以及处理敏感个人信息，我们会根据您的实际使用情况单独征求您的同意。
    </p>
    <p>一、适用范围</p>
    <p>
      您点击签署本协议的同时表示您已了解应用提供的功能，以及功能运行所需的必要个人信息，并给予相应的收集使用授权，但并不代表您已单独同意开启附加功能、处理非必要个人信息，相关附加功能的开启、处理非必要个人信息以及处理敏感个人信息，我们会根据您的实际使用情况单独征求您的同意。
    </p>
    <p>二、信息收集及使用</p>
    <p>在您使用我们的平台服务时，我们可能需要收集和使用的您的个人信息如下：</p>
    <p>（一）注册信息</p>

    <p>
      为了便于您注册、正常使用本平台服务的基本功能，须授权我们收集、使用的必要的信息，包括但不限于手机号码、联系人姓名、电子邮箱等。如您拒绝提供相应信息，您将无法正常使用本平台服务。
    </p>
    <p>（二）商品展示或服务信息</p>
    <p>
      关于商品展示或服务信息，包括您的访问足迹、历史搜索等情况，我们会收集和使用您在访问或使用平台时的浏览、搜索记录。我们会结合依法收集的设备信息、服务日志信息，以及其他取得您授权的信息，通过算法模型预测您的偏好特征，匹配您可能感兴趣的商品、服务或其他信息，对向您展示的商品、服务或其他信息进行排序。为满足您的多元需求，我们会在排序过程中引入多样化推荐技术，拓展推荐的内容，避免同类型内容过度集中。我们也会基于您的偏好特征在平台及其他第三方应用程序向您推送您可能感兴趣的商业广告及其他信息，或者向您发送商业性短信息。
    </p>
    <p>（三）收藏、加购、关注与分享功能</p>
    <p>
      在您浏览我们平台的过程中，您可以选择对感兴趣的商品进行收藏、添加至购物车、与您感兴趣的商家或品牌建立关系、通过我们提供的功能组件向第三方分享商品或服务信息。在您使用上述功能的过程中，我们会收集包括您的收藏及添加购物车的记录、关注关系、分享历史在内的服务日志信息用于实现上述功能及其他我们明确告知的目的。
    </p>
    <p>（四）订单管理</p>
    <p>
      当您在我们的平台服务中出售或采购具体商品或服务时，我们会通过系统为您生成该商品或服务的订单，收集订单中载明您所出售或采购的商品或服务信息、具体订单号、订单创建时间、您应支付的金额、您的备注信息、其他联系电话、收货时间及其他附加信息。
    </p>
    <p>（五）支付方式</p>
    <p>
      1、为保证您销售或购买的商品或服务能够顺利、安全、准确送达、提供，我们会向为平台提供物流信息系统和技术服务的公司披露订单相关的配送信息，并由其根据商品或服务提供主体的选择向相应的物流配送主体同步相关配送信息。您知晓并同意相应物流配送主体不可避免地获知及使用您的配送信息，用于完成交付目的。
    </p>
    <p>
      2、为向您提供售后与争议解决服务之目的，我们需要及时获悉并确认交付进度及状态，您同意我们可自物流相关服务主体处收集与交付进度相关的信息。
    </p>
    <p>（六）商品或服务的交付</p>
    <p>
      1、为保证您销售或购买的商品或服务能够顺利、安全、准确送达、提供，我们会向为平台提供物流信息系统和技术服务的公司披露订单相关的配送信息，并由其根据商品或服务提供主体的选择向相应的物流配送主体同步相关配送信息。您知晓并同意相应物流配送主体不可避免地获知及使用您的配送信息，用于完成交付目的。
    </p>
    <p>
      2、为向您提供售后与争议解决服务之目的，我们需要及时获悉并确认交付进度及状态，您同意我们可自物流相关服务主体处收集与交付进度相关的信息。
    </p>
    <p>（七）客服及争议处理</p>
    <p>
      1、当您与我们联系或提出售中、售后、争议纠纷处理申请时，为了保障您的账户及系统安全，我们需要您提供必要的个人信息以核验您的身份。为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的沟通、通信、通话记录及相关内容（包括账户信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息）。如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的账户信息和订单信息。
    </p>
    <p>
      2、为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。
    </p>
    <p>（八）信息公开发布功能</p>
    <p>
      您可通过我们为您提供的评论、个人主页及其他信息发布功能，选择公开发布图文、发表评价及问答内容，以及作为卖家发布商品或服务相关信息、店铺相关信息。我们尊重并保护您对相关信息是否发布以及发布范围的设置。我们可能会根据您的账户类型及网络日志信息，判断您是否可享受对应信息发布功能权限。
    </p>
    <p>
      请注意，您公开发布的信息中可能会涉及您或他人的个人信息甚至敏感个人信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。若您公开发布的信息中涉及他人个人信息的，您需在发布前征得他人的同意。
    </p>
    <p>（九）安全保障</p>
    <p>
      为履行保障交易安全的法定义务，提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入风险，更准确地识别违反法律法规或平台相关协议、规则的情况，我们可能会使用或整合您的会员信息、交易信息、设备信息、服务日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
    </p>
    <p>（十）其他附加服务</p>
    <p>1、基于系统权限的附加服务</p>
    <p>
      为向您提供更便捷、更优质、个性化的平台服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会通过开启系统权限以收集和使用您的个人信息。如果您不同意开启相关权限，不会影响您使用平台的基本服务，但您可能无法获得这些附加服务给您带来的用户体验。
    </p>
    <p>您可自行决定这些权限随时的开启或关闭。</p>
    <p>
      请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法继续为您提供该权限所对应的服务。您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
    </p>
    <p>2、Cookie和同类技术的服务</p>
    <p>
      Cookie和同类设备信息标识技术是互联网中普遍使用的技术。当您使用我们的服务时，我们可能会使用相关技术向您的设备发送一个或多个
      Cookie
      或匿名标识符（以下简称“Cookie”），以收集、标识和存储您访问、使用平台时的信息。我们承诺，不会将
      Cookie 用于本隐私政策所述目的之外的任何其他用途。我们使用 Cookie
      主要为了保障产品与服务的安全、高效运转，可以使我们确认您账户与交易的安全状态，排查崩溃、延迟的相关异常情况，帮助您省去重复您填写表单、输入搜索内容的步骤和流程。
    </p>
    <p>
      同时，我们可能会利用 Cookie
      向您展示您可能感兴趣的信息或功能，并优化您对广告的选择。您可以进行相应的数据清除操作，或可修改对Cookie的接受程度或拒绝我们的Cookie。您可能因为这些修改，无法使用依赖于Cookie的服务或相应功能。
    </p>
    <p>三、用户信息的共享、委托处理、转让和公开披露</p>
    <p>（一）共享</p>
    <p>
      我们不会向平台服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
    </p>
    <p>
      1、履行法定义务所必需的共享：我们可能会根据法律法规规定、诉讼、争议解决的必要，或按行政、司法机关依法提出的要求，以及其他法定义务履行的必需，共享您的个人信息。
    </p>
    <p>
      2、取得您同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
    </p>
    <p>
      3、为订立、履行您作为一方当事人的合同所必需的情况下的共享：您通过平台出售或购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易、配送及售后服务需求。
    </p>
    <p>
      4、与关联公司间共享：为便于我们与关联公司共同向您提供部分服务，基于平台账户向您提供产品和服务，推荐您可能感兴趣的信息，识别账户异常，保护平台关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司或其指定的服务提供商共享。我们只会共享必要的个人信息，且受本协议中所声明目的的约束，如果我们共享您的敏感个人信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
    </p>
    <p>
      请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至敏感个人信息。请您更加谨慎地考虑并做出决定。
    </p>
    <p>（二）委托处理</p>
    <p>
      我们可能委托授权合作伙伴处理您的个人信息，以便授权合作伙伴代表我们为您提供某些服务或履行职能。我们仅会出于本协议声明的合法、正当、必要、特定、明确的目的委托其处理您的信息，授权合作伙伴只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何超出委托范围的目的。如果授权合作伙伴将您的信息用于我们未委托的用途，其将单独征得您的同意。
    </p>
    <p>（三）转让</p>
    <p>
      如果我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式。接收方将继续履行本协议及其他法定义务。接收方变更原先的处理目的、处理方式的，会重新取得您的同意。
    </p>
    <p>（四）公开披露</p>
    <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
    <p>
      1、基于您的主动选择及其他单独同意的情况下，我们可能会公开披露您的个人信息；
    </p>
    <p>
      2、如果我们确定您出现违反法律法规或严重违反平台相关协议及规则的情况，或为保护平台用户或公众的人身财产安全免遭侵害，我们可能披露关于您的个人信息，包括相关违规行为以及平台已对您采取的措施。
    </p>
    <p>四、用户权利</p>
    <p>
      您可以通过以下方式查阅和管理您的信息，我们会在符合法律法规要求的情形下响应您的请求：
    </p>
    <p>（一）查阅、更正和补充</p>
    <p>您有权通过以下方式查阅、更正和补充您的信息：</p>
    <p>1、登录平台，进入设置页面进行操作；</p>
    <p>2、电话联系客服进行操作。</p>
    <p>（二）删除</p>
    <p>在以下情形中，您可以通过与客服联系向我们提出删除个人信息的请求：</p>
    <p>1、如果我们处理个人信息的行为违反法律法规；</p>
    <p>2、如果我们收集、使用您的个人信息，却未征得您的明确同意；</p>
    <p>3、如果我们处理个人信息的行为严重违反了与您的约定；</p>
    <p>4、如果我们的处理目的已实现、无法实现或者为实现处理目的不再必要；</p>
    <p>5、如果我们停止提供产品或者服务，或者保存期限已届满。</p>
    <p>
      若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。
    </p>
    <p>
      当您或我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以清除或实现匿名化。
    </p>
    <p>（三）改变授权范围</p>
    <p>
      您可以通过客服联系进行修改，但请注意，对于部分类型的个人信息，例如实现平台基本功能所必须的信息或者我们履行法律法规规定的义务所必需的信息，我们可能无法响应您改变授权范围的请求。当您撤回授权后，我们将不再处理相应的个人信息。但您撤回授权的决定，不会影响我们此前基于您的授权而开展的个人信息处理。
    </p>
    <p>（四）注销账户</p>
    <p>
      您可以通过通过客服联系，申请注销您的账户。在您主动注销账户之后，我们将停止为您提供产品或服务，并根据适用法律的要求删除或匿名化处理您的个人信息。
    </p>
    <p>（五）约束信息系统自动决策</p>
    <p>
      在某些业务功能中，我们可能仅依据算法在内的非人工自动决策机制做出决定。如果这些决定影响您的合法权益，您可以通过客服联系我们。
    </p>
    <p>（六）复制您的个人信息</p>
    <p>
      您可以通过与客服联系向我们提出复制个人信息的请求，但法律法规另有规定除外。
    </p>
    <p>（七）响应您的上述请求</p>
    <p>
      1、对于您或可能的您的监护人、近亲属及其他有权主体向我们提出上述请求，以及中华人民共和国法律与其他适用法律规定的您的相关个人信息权利，您可以通过客服联系我们发起投诉。我们将在15天内做出答复。
    </p>
    <p>
      2、为保障您的账户安全和您的个人信息安全，您向我们提出上述请求时，我们可能会先验证您的身份（如增加账户核验、要求您提供书面请求或其他合理方式），然后再处理您的请求。
    </p>
    <p>
      3、对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将酌情收取一定费用。对于与您的身份不直接关联的信息、无合理理由重复申请的信息，或者需要过多技术手段（如需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。
    </p>
    <p>五、用户信息的存储</p>
    <p>（一）存储期限</p>
    <p>
      我们只会在达成本协议所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，我们判断个人信息的存储期限主要依据以下标准：
    </p>
    <p>
      1、完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；
    </p>
    <p>2、保证我们为您提供服务的安全和质量；</p>
    <p>3、您是否同意更长的留存期间；</p>
    <p>4、保证我们在可能的诉讼案件中向法院进行举证；</p>
    <p>5、是否存在关于保留期限的其他特别约定或法律法规规定。</p>
    <p>
      在超出保留期间后，我们会根据适用法律的要求删除或匿名化处理您的个人信息。
    </p>
    <p>（二）存储位置</p>
    <p>
      我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。以下情形下，我们会在履行法律规定的义务后，向可能的境外实体提供您的个人信息：
    </p>
    <p>1、适用的法律有明确规定；</p>
    <p>2、获得您的单独同意；</p>
    <p>
      3、您作为一方当事人的跨境电子商务交易及其他类型合同订立和履行所必需的。
    </p>
    <p>针对以上情形，我们会按照本协议依法保护您的个人信息安全。</p>
    <p>（三）存储安全</p>
    <p>
      我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。
    </p>
    <p>六、用户信息安全事件</p>
    <p>
      1、如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损的，我们会及时启动应急预案，采取合理必要的措施，以尽可能降低对您个人的影响。如发生个人信息安全事件，我们还将按照法律法规的要求向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将以短信、电话、推送通知及其他合理渠道告知您，难以逐一告知的，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
    </p>
    <p>
      2、在使用平台服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。此外，您也可以通过我们的服务与第三方建立沟通、交流信息或分析内容。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供，不轻信通过其他交易工具进行交易，以免信息被窃取甚至遭遇电信网络诈骗。
    </p>
    <p>
      如您担心自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络我们的客服以便我们根据您的申请采取相应措施。您也可以自主进行登录密码修改。
    </p>
    <p>七、政策的更新</p>
    <p>
      为给您带来更好的产品和服务体验，我们持续努力改进我们的产品、服务及技术。在新的服务及业务流程变更时，我们可能会更新我们的隐私政策。您理解并同意，我们有权根据发展需要单方修订本协议，并以修订后的版本完全替代修订前的版本。请您及时关注和了解本政策的修订情况，若您不同意修订后版本，您应立即停止使用本平台服务，否则即视同您同意并完全接受修订后的版本。
    </p>
    <p>八、未成年人使用条款</p>
    <p>
      我们的服务主要面向商家。如果没有父母或监护人的同意，未成年人不应创建任何账户或使用本平台及其服务。如果我们发现在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。
    </p>
  </div>
</template>

<script>
export default {
  name: "xieyi"
};
</script>

<style scoped lang="less">
.xieyi {
  color: #333;
  padding: 30px;
  background: #f8faff;
  h2 {
    font-size: 34px;
    text-align: center;
  }
  p {
    font-size: 24px;
    margin-top: 20px;
    text-indent: 2em;
    line-height: 46px;
  }
}
</style>
